
















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";

// import {json2excel} from 'js2excel';
import GlobalMixins from "@/global.mixin";
import appSnackbarService from "@/services/appSnackbar.service";

interface InventoryItem {
  inventoryId: number;
  description: string;
  startDt: Date|null;
  endDt: Date|null;
  siteId: number|null;
  locationId: number|null;
  relocation: boolean;
}

@Component({
  mixins: [GlobalMixins],
  components: {  }
})
export default class InventoryView extends Vue {

  @State("inventory") inventoryState: any;
  @Action("getInventory") getInventory: any;
  @Action("inventoryNew") inventoryNew: any;
  @Action("inventoryClose") inventoryClose: any;
  @Action("getInventoryAll") getInventoryAll: any;
  @Action("getInventoryItemCount") getInventoryItemCount: any;
  @Action("inventoryIsAnyOpen") inventoryIsAnyOpen: any;

  @State("sites") sitesState: any;
  @Action("getSites") getSites: any;

  dialogInventoryClose = false;

  locationsSearchTerm = "";
  locationsSearched: string[] = [];

  sitesSearchTerm = "";
  sitesSearched: string[] = [];

  formValid = false;

  editingDialog = false;
  search = "";
  editedIndex = -1;
  isNewInventory = false;

  defaultItem: InventoryItem = {
    inventoryId: 0,
    description: "",
    startDt: null,
    endDt: null,
    siteId: -1,
    locationId: -1,
    relocation: false,
  };
  editedItem = Object.assign({}, this.defaultItem);

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "inventoryId",
    descending: true,
    page: 1,
    rowsPerPage: this.$cookies.isKey("inventory-rowsPerPage") ?
                        parseInt(this.$cookies.get("inventory-rowsPerPage"), 10) : 25
  };


  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  async created() {

    await this.getSites();

    this.searchSites();
  }

  searchSites() {
    if (!this.sitesSearchTerm) {
      this.sitesSearched = this.sitesState.sites;
      return;
    }

    const term = this.sitesSearchTerm.toLowerCase();
    this.sitesSearched = this.sitesState.sites.filter((item) => {
      return item.code.toLowerCase().indexOf(term) > -1 || item.description.toLowerCase().indexOf(term) > -1;
    });
  }

  getHeaders() { return[
      { text: "#", value: "inventoryId", width: "1%", align: "left"},
      { text: this.$t("INVENTORY_TABLE_SITE"), align: "left", sortable: true, value: "site.code", },
      { text: this.$t("INVENTORY_TABLE_SITE_NAME"), align: "left", sortable: true, value: "site.description", },
      { text: this.$t("INVENTORY_TABLE_DESCRIPTION"), align: "left", sortable: true, value: "description", },
      { text: this.$t("INVENTORY_TABLE_RELOCATION"), align: "left", sortable: true, value: "relocation", },
      { text: this.$t("INVENTORY_TABLE_START"), align: "left", sortable: true, value: "startDt",  },
      { text: this.$t("INVENTORY_TABLE_END"), align: "left", sortable: true, value: "endDt",  },
      { text: this.$t("INVENTORY_TABLE_FOUND"), align: "center", sortable: false, value: "itemCount",  },
      { text: this.$t("INVENTORY_TABLE_DETAILS"), align: "center", sortable: false, value: "details",  },
      { text: this.$t("TABLE_ACTIONS"), value: "actions", sortable: false },
    ];
  }
  reload() {
    this.updatePagination(this.pagination);
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {

    this.$cookies.set("inventory-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
    };
    this.getInventory(page)
    .then( () => {
      this.getInventoryItemCount()
      .then( () => {
        this.$forceUpdate();
      });
    });
  }

  closeInventory(item) {
    this.editedIndex = this.inventoryState.inventory.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialogInventoryClose = true;
  }

  inventoryCloseConfirm() {
    this.editedItem.endDt = new Date() as Date;

    this.inventoryClose({id: this.editedItem.inventoryId, data: this.editedItem, index: this.editedIndex})
    .then(() => {
      this.inventoryIsAnyOpen();
      this.closeInventoryClose();
    });

  }

  close() {
    this.editingDialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
    if (this.$refs.form) {
      // this.$refs.form.resetValidation();
      (this.$refs.form as Vue & { resetValidation: () => void }).resetValidation();
    }
  }

  closeInventoryClose() {
    this.dialogInventoryClose = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  save() {
    console.log(this.editedItem);
    // if (this.$refs.form.validate()) {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      if (this.editedIndex === -1) {
        this.editedItem.startDt = new Date();
      }

      this.inventoryNew({data: {
          ...this.editedItem,
          locationId: this.editedItem.locationId !== -1 ? this.editedItem.locationId : null
        },
        index: this.editedIndex
      })
      .then( () => {
        this.close();
        this.editedIndex = -1;
        this.inventoryIsAnyOpen();
      })
      .catch( err => {
        // appSnackbarService.error(err);
      });
    }
  }

  retrieveCount(item) {
    // TODO: start using it
    appSnackbarService.success("retrieveCount:", item.inventoryId);
  }

  inventoryDetails(item) {
    // console.log("inventoryDetails: ", item);

    this.$router.push({
      name: "INVENTORY_DETAILS_TITLE",
      params: { inventoryId: item.inventoryId },
    });
  }
}
